import type { IBusiness, ITransaction } from '@recargas-dominicanas/core/types';
import { center, colums, line, newLine, print } from './print';
import { formatCurrency, formatPhone, formatTime, formatVigency } from '@recargas-dominicanas/core/utils';
import { formatDatePart } from './formatDate';

export function printInsurance(business: IBusiness, transaction: ITransaction) {
  print([
    center(business.name.toLocaleUpperCase()),
    center(formatPhone(business.phone)),
    center(business.address),
    newLine(),
    line(),
    center('SEGURO DE LEY'),
    line(),
    newLine(),
    colums('Compañía', transaction.product.name),
    colums('Vehiculo', transaction.insurance!.vehicleName),
    colums('Chasis', transaction.insurance!.chassis),
    colums('Poliza', transaction.insurance!.policy),
    colums('Vigencia', formatVigency(transaction.insurance!.vigency)),
    colums('Precio', formatCurrency(transaction.amount)),
    colums('Cédula', transaction.insurance!.docNumber),
    colums('Teléfono', formatPhone(transaction.insurance!.phone)),
    colums('Fecha', formatDatePart(transaction.date)),
    colums('Hora', formatTime(transaction.date)),
    colums('Fecha de expiración', formatDatePart(transaction.insurance!.expiresAt)),
    colums('Referencia', transaction.insurance!.id),
    newLine(),
    line(),
    ...midasContactInfo(transaction),
    center(transaction.cancelled ? 'SEGURO CANCELADO' : '¡Gracias por su compra!'),
    newLine()
  ]);
}

function midasContactInfo(transaction: ITransaction) {

  if (transaction.product.key !== 'midas:insurance') return [];

  return [
    newLine(),
    center(`Servicio al cliente ${transaction.product.name}`),
    center('(809) 563-9573'),
    newLine(),
    line(),
  ];
}
